import { ToastContainer } from "react-toastify";
import "./style.scss";
import { ReactComponent as IconError } from "../../assets/ic-close.svg";

const CloseButton = ({ closeToast }) => (
  <button
    onClick={closeToast}
    className="text-tertiary btn-resetStyle Toastify__close-button"
  >
    <IconError />
  </button>
);

const CustomToastContainer = () => (
  <ToastContainer
    closeButton={CloseButton}
    autoClose={3000}
    closeOnClick
    rtl={false}
    theme="dark"
  />
);

export default CustomToastContainer;
